import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import PatientInteraction from 'common-src/models/PatientInteraction';
import { extractLabOrder, getFilteredPatientLabOrders } from 'common-src/models/PatientLabOrder';

import { LabOrders } from 'src/components/forms';
import { getTimer } from 'src/features/timeTracker';
import useCustomSelector from 'src/hooks/useCustomSelector';
import { ModuleTitle } from 'src/pages/DocumentationIndex/components';

import styles from './LabOrdersModule.module.scss';

const LabOrdersModule = ({
  patientId,
  labOrders,
  setLabOrders,
  errors,
  setHasDetectedChanges,
  documentationToEdit,
}) => {
  const filteredPatientLabOrders = useCustomSelector((state) =>
    getFilteredPatientLabOrders(state, patientId),
  );
  const timer = useCustomSelector((state) => getTimer(state, patientId));

  useEffect(() => {
    const initialLabOrders =
      timer &&
      documentationToEdit.primaryModuleTypeId &&
      !_.isEmpty(documentationToEdit?.draftData?.labOrders)
        ? documentationToEdit?.draftData?.labOrders
        : filteredPatientLabOrders.map(extractLabOrder);

    setLabOrders(initialLabOrders);
    setHasDetectedChanges(new Date());
  }, []);

  return (
    <div className={styles.container}>
      <ModuleTitle title="Lab Orders" tooltipMessage="Lab orders since last neurologist visit" />
      <LabOrders
        patientId={patientId}
        isEditMode
        formData={labOrders}
        setFormData={(data) => {
          setLabOrders(data);
          setHasDetectedChanges(new Date());
        }}
        errors={Object.fromEntries(errors)}
        setErrors={() => {}}
        patientLabOrders={filteredPatientLabOrders}
      />
    </div>
  );
};

LabOrdersModule.propTypes = {
  patientId: PropTypes.number,
  labOrders: PropTypes.array,
  setLabOrders: PropTypes.func,
  errors: PropTypes.object,
  setHasDetectedChanges: PropTypes.func,
  documentationToEdit: PropTypes.exact(PatientInteraction.schema),
};

export default LabOrdersModule;
